import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import CollectionForm from "components/form/CollectionForm";

import useCollectionForm from "hooks/form/useCollectionForm";

function NuovaCollezione() {
    const formCollectionHook = useCollectionForm();

    const { buttonSave } = formCollectionHook;

    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Aggiungi Collezione</h1>
                </GridItem>
            </GridRow>

            <CollectionForm formCollectionHook={formCollectionHook} />

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={buttonSave}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </>
    );
}

export default NuovaCollezione;
